import lodash from 'lodash'

import {
  GET_CLIENTCONTRACTS_REQUESTED,
  GET_CLIENTCONTRACTS_SUCCESS,
  GET_CLIENTCONTRACTS_FAILED,
  ADD_CLIENTCONTRACTS_REQUESTED,
  ADD_CLIENTCONTRACTS_SUCCESS,
  ADD_CLIENTCONTRACTS_FAILED,
  GET_CLIENTCONTRACT_REQUESTED,
  GET_CLIENTCONTRACT_SUCCESS,
  GET_CLIENTCONTRACT_FAILED,
  GET_PROLONGCALCULATE_REQUESTED,
  GET_PROLONGCALCULATE_SUCCESS,
  GET_PROLONGCALCULATE_FAILED,
  ADD_PROLONGCALCULATE_REQUESTED,
  ADD_PROLONGCALCULATE_SUCCESS,
  ADD_PROLONGCALCULATE_FAILED,
  CHANGE_CLIENTCONTRACT_REQUESTED,
  CHANGE_CLIENTCONTRACT_SUCCESS,
  CHANGE_CLIENTCONTRACT_FAILED,
  GET_OPERATIONSCONTRACT_REQUESTED,
  GET_OPERATIONSCONTRACT_SUCCESS,
  GET_OPERATIONSCONTRACT_FAILED,
  CHANGE_CONTRACTSTATUSES_REQUESTED,
  CHANGE_CONTRACTSTATUSES_SUCCESS,
  CHANGE_CONTRACTSTATUSES_FAILED,
  GET_TRANSACTIONS_REQUESTED,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAILED,
  CHANGE_POSITIONSCONTRACT_REQUESTED,
  CHANGE_POSITIONSCONTRACT_SUCCESS,
  CHANGE_POSITIONSCONTRACT_FAILED,
  TRANSFER_DEALS_REQUESTED,
  TRANSFER_DEALS_SUCCESS,
  TRANSFER_DEALS_FAILED,
  GET_INVENTORIES_REQUESTED,
  GET_INVENTORIES_SUCCESS,
  GET_INVENTORIES_FAILED,
  GET_INVENTORYDEALS_REQUESTED,
  GET_INVENTORYDEALS_SUCCESS,
  GET_INVENTORYDEALS_FAILED,
  GET_DEALSFORTRANSFER_REQUESTED,
  GET_DEALSFORTRANSFER_SUCCESS,
  GET_DEALSFORTRANSFER_FAILED,
  TRANSFER_SALED_REQUESTED,
  TRANSFER_SALED_SUCCESS,
  TRANSFER_SALED_FAILED,
  OVERESTIMATION_DEALS_REQUESTED,
  OVERESTIMATION_DEALS_SUCCESS,
  OVERESTIMATION_DEALS_FAILED,
  CANCEL_OPERATION_REQUESTED,
  CANCEL_OPERATION_SUCCESS,
  CANCEL_OPERATION_FAILED,
  GET_PRINTEDFORM_REQUEST,
  GET_PRINTEDFORM_SUCCESS,
  GET_PRINTEDFORM_FAILED,
  PROLONG_CALCULATE_CLEAR,
  CHANGE_CONTRACT_CLEAR,
  CONTRACT_ID_CLEAR,
  CLIENT_CONTRACT_CLEAR,
  CONTRACT_STATE_RESET,
  CONTRACT_SAVE_RESET,
  CANCEL_CONTRACT_REQUEST,
  CANCEL_CONTRACT_SUCCESS,
  CANCEL_CONTRACT_FAILED,
  MODAL_ERROR_CLEAR,
  TRANSFER_TO_RETENTION_REQUESTED,
  TRANSFER_TO_RETENTION_SUCCESS,
  TRANSFER_TO_RETENTION_FAILED,
  SWITCH_CONTRACT_JEWELLERY,
  SWITCH_CONTRACT_THINGS,
  CONTRACT_ERROR_CLEAR,
  GET_PARTIAL_QUENCHING_DATA_REQUESTED,
  GET_PARTIAL_QUENCHING_DATA_SUCCESS,
  GET_PARTIAL_QUENCHING_DATA_FAILED,
  PARTIAL_QUENCHING_DATA_CLEAR,
  CONTRACT_PARTIAL_QUENCHING_SUCCESS,
  CONTRACT_PARTIAL_QUENCHING_FAILED,
  SWITCH_CONTRACT_CARS,
  SET_SELECTED_ITEMS,
  RESET_SELECTED_ITEMS,
  GET_WEB_FORM_SUCCESS,
  RESET_WEB_FORM,
  STATE_MODAL_ADD_CONTRACT,
  OVERESTIMATION_REQUEST_SUCCESS,
  SET_LOAD_PRA_FILE,
  CHANGE_STATE_PRA_MODAL,
  STATE_LOADER,
  LOAD_PRA_SUCCESS,
  OPEN_ALERT_PRA,
  LOAD_PRA_FAILED,
  CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED,
  CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED,
  GET_CLIENTSCOUNT_RERQUEST,
  GET_CLIENTSCOUNT_SUCCESS,
  GET_CLIENTSCOUNT_FAILED,
  RESET_CLIENTS_COUNT,
  GET_PAYMENTS_ANNUITY_SUCCESS,
  PAY_ANNUITY_PERIOD_SUCCESS,
  PAY_ANNUITY_PERIOD_FAILED,
  GET_PAYMENTS_ANNUITY_REQUESTED,
  GET_PAYMENTS_ANNUITY_FAILED,
  GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED,
  GET_CALC_ANNUITY_CLOSE_DEAL_SUCCESS,
  GET_CALC_ANNUITY_CLOSE_DEAL_FAILED,
  CLOSE_ANNUITY_DEAL_REQUESTED,
  CLOSE_ANNUITY_DEAL_SUCCESS,
  CLOSE_ANNUITY_DEAL_FAILED,
  PAY_ANNUITY_PERIOD_REQUESTED,
  SET_MODAL_ERROR, CLOSE_ANNUITY_STATE, ANNUITY_PERIOD_STATE,
} from '../actions/actionTypes'

const initialState = {
  clientContracts: {
    deal: [],
    total: 0
  },
  clientContract: {},
  prolongCalculate: [],
  saveProlongCalculate: null,
  commonError: '',
  isLoading: false,
  contractID: null,
  isModalLoading: false,
  modalError: '',
  isModalResponse: false,
  changeContract: false,
  isTabLoading: false,
  operations: [],
  transactions: {},
  inventoriesData: {
    inventories: [],
    total: 0
  },
  inventory: {},
  dealsForTransfer: [],
  typeOfDeal: 'jewellery',
  fileError: '',
  selectedItems: new Map(),
  report: null,
  clientsCount: null,
  isClientCountLoading: false,
  partialQuenchingData: {},
  coupons: [],
  isModal: false,
  dealSuccess: null,
  praFile: null,
  isPraModal: false,
  isAlert: false,
  errorPra: '',
  praStatus: null,
  periodsPaymentAnnuityDeal: {},
  isSuccessAnnuityPeriod: false,
  calcAnnuityData: {},
  isSuccessCloseAnnuityDeal: false,
  isDisabledButton: false,
  closeAnnuityData: {},
  payPeriodAnnuity: {},
  contractError: ''
}

const contractReducer = (state = lodash.cloneDeep(initialState), action) => {
  switch (action.type) {
    case CLOSE_ANNUITY_DEAL_SUCCESS:

      return {
        ...state,
        isSuccessCloseAnnuityDeal: true,
        isDisabledButton: false,
        commonError: '',
        closeAnnuityData: action.payload,
      }
      case CLOSE_ANNUITY_DEAL_REQUESTED:
      return {
        ...state,
        isDisabledButton: true,
        commonError: '',
      }
      case CLOSE_ANNUITY_DEAL_FAILED:
      return {
        ...state,
        isSuccessCloseAnnuityDeal: false,
        isDisabledButton: false,
        modalError: action.payload,
      }
      case GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        commonError: '',
        isSuccessCloseAnnuityDeal: false,
      }
      case CLOSE_ANNUITY_STATE:
      return {
        ...state,
        isModalLoading: true,
        commonError: '',
        isSuccessCloseAnnuityDeal: false,
      }
      case ANNUITY_PERIOD_STATE:
      return {
        ...state,
        isModalLoading: true,
        commonError: '',
        isSuccessAnnuityPeriod: false,
      }
      case GET_CALC_ANNUITY_CLOSE_DEAL_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        calcAnnuityData: action.payload,
        commonError: '',
        isSuccessCloseAnnuityDeal: false,

      }
      case SET_MODAL_ERROR:
      return {
        ...state,
        modalError: action.payload,
      }
      case GET_CALC_ANNUITY_CLOSE_DEAL_FAILED:
      return {
        ...state,
        isModalLoading: false,
      }
    case LOAD_PRA_FAILED:
      return {
        ...state,
        errorPra: action.payload,
        isLoading: false
      }
      case PAY_ANNUITY_PERIOD_REQUESTED:
      return {
        ...state,
        isModalLoading: false,
        isDisabledButton: true
      }
      case GET_PAYMENTS_ANNUITY_SUCCESS:
      return {
        ...state,
        periodsPaymentAnnuityDeal: action.payload,
        isModalLoading: false,
      }
      case GET_PAYMENTS_ANNUITY_FAILED:
      return {
        ...state,
        isModalLoading: false,
      }
      case GET_PAYMENTS_ANNUITY_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        isSuccessAnnuityPeriod: false,
      }
      case PAY_ANNUITY_PERIOD_FAILED:
        return {
        ...state,
        modalError: action.payload,
        isLoading: false,
        isDisabledButton: false,
        periodsPaymentAnnuityDeal: {...state.periodsPaymentAnnuityDeal},
      }
      case PAY_ANNUITY_PERIOD_SUCCESS:
      return {
        ...state,
        isSuccessAnnuityPeriod: true,
        isLoading: false,
        isDisabledButton: false,
        payPeriodAnnuity: action.payload
      }
    case OPEN_ALERT_PRA:
      return {
        ...state,
        isAlert: false
      }
    case LOAD_PRA_SUCCESS:
      return {
        ...state,
        isPraModal: false,
        isLoading: false,
        isAlert: true,
        praStatus: action.payload
      }
    case STATE_LOADER:
      return {
        ...state,
        isLoading: action.payload
      }
    case CHANGE_STATE_PRA_MODAL:
      return {
        ...state,
        isPraModal: action.payload
      }
    case SET_LOAD_PRA_FILE:
      return {
        ...state,
        praFile: action.payload
      }
    case STATE_MODAL_ADD_CONTRACT:
      return {
        ...state,
        isModal: action.payload
      }
    case OVERESTIMATION_REQUEST_SUCCESS:
      return {
        ...state,
        dealSuccess: action.payload
      }
    case GET_WEB_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        report: action.payload,
        commonError: '',
      }
    case RESET_WEB_FORM:
      return {
        ...state,
        isLoading: false,
        report: null,
      }
    case SET_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: action.payload
      }
    case RESET_SELECTED_ITEMS:
      let msp = state.selectedItems;
      msp.clear();
      return {
        ...state,
        selectedItems: msp
      }
    case GET_PARTIAL_QUENCHING_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }
    case GET_PARTIAL_QUENCHING_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        partialQuenchingData: action.payload,
      }
    case GET_PARTIAL_QUENCHING_DATA_FAILED:
      return {
        ...state,
        isLoading: false,
        modalError: action.payload
      }
    case PARTIAL_QUENCHING_DATA_CLEAR:
      return {
        ...state,
        partialQuenchingData: {},
      }
    case CONTRACT_PARTIAL_QUENCHING_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        isModalResponse: action.payload,
      }
    case CONTRACT_PARTIAL_QUENCHING_FAILED:
      return {
        ...state,
        isLoading: false,
        modalError: action.payload
      }
    case GET_CLIENTCONTRACTS_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_CLIENTCONTRACTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientContracts: { deal: action.payload.deal, total: action.payload.totalElements }
      }
    case GET_CLIENTCONTRACTS_FAILED:
      return {
        ...state,
        clientContracts: {
          deal: [],
          total: 0
        },
        isLoading: false,
        commonError: action.payload
      }
    case ADD_CLIENTCONTRACTS_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case ADD_CLIENTCONTRACTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contractID: action.payload,
      }
    case ADD_CLIENTCONTRACTS_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload,
        isModal: false
      }
    case GET_CLIENTCONTRACT_REQUESTED:
      return {
        ...state,
        isModalResponse: false,
        isLoading: true,
        commonError: '',
        modalError: '',
      }
    case GET_CLIENTCONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientContract: action.payload
      }
    case GET_CLIENTCONTRACT_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_PROLONGCALCULATE_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        modalError: ''
      }
    case GET_PROLONGCALCULATE_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        prolongCalculate: action.payload
      }
    case GET_PROLONGCALCULATE_FAILED:
      return {
        ...state,
        isModalLoading: false,
        modalError: action.payload
      }
    case ADD_PROLONGCALCULATE_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        modalError: ''
      }
    case ADD_PROLONGCALCULATE_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        saveProlongCalculate: action.payload
      }
    case ADD_PROLONGCALCULATE_FAILED:
      return {
        ...state,
        isModalLoading: false,
        modalError: action.payload
      }
    case CHANGE_CLIENTCONTRACT_REQUESTED:
      return {
        ...state,
        changeContract: false
      }
    case CHANGE_CLIENTCONTRACT_SUCCESS:
      return {
        ...state,
        changeContract: true
      }
    case CHANGE_CLIENTCONTRACT_FAILED:
      return {
        ...state,
        commonError: action.payload
      }
    case GET_OPERATIONSCONTRACT_REQUESTED:
      return {
        ...state,
        isTabLoading: true,
        commonError: ''
      }
    case GET_OPERATIONSCONTRACT_SUCCESS:
      return {
        ...state,
        isTabLoading: false,
        operations: action.payload.listOperations
      }
    case GET_OPERATIONSCONTRACT_FAILED:
      return {
        ...state,
        isTabLoading: false,
        commonError: action.payload
      }
    case CHANGE_CONTRACTSTATUSES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: '',
        changeContract: false,
      }
      case CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: '',
        changeContract: false,
      }
    case CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: '',
        changeContract: false,
      }
    case CHANGE_CONTRACTSTATUSES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        changeContract: true,
      }
    case CHANGE_CONTRACTSTATUSES_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_TRANSACTIONS_REQUESTED:
      return {
        ...state,
        isTransactionsLoading: true,
        commonError: '',
      }
    case GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isTransactionsLoading: false,
        transactions: action.payload,
      }
    case GET_TRANSACTIONS_FAILED:
      return {
        ...state,
        isTransactionsLoading: false,
        commonError: action.payload
      }
    case CHANGE_POSITIONSCONTRACT_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        modalError: ''
      }
    case CHANGE_POSITIONSCONTRACT_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        isModalResponse: action.payload,
      }
    case CHANGE_POSITIONSCONTRACT_FAILED:
      return {
        ...state,
        isModalLoading: false,
        modalError: action.payload
      }
    case TRANSFER_DEALS_REQUESTED:
      return {
        ...state,
        changeContract: false
      }
    case TRANSFER_DEALS_SUCCESS:
      return {
        ...state,
        changeContract: true
      }
    case TRANSFER_DEALS_FAILED:
      return {
        ...state,
        commonError: action.payload
      }
    case GET_INVENTORIES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_INVENTORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        inventoriesData: { inventories: action.payload?.transfers ? action.payload.transfers : [], total: action.payload?.totalElements ? action.payload.totalElements : 0 }
      }
    case GET_INVENTORIES_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_INVENTORYDEALS_REQUESTED:
      return {
        ...state,
        isTabLoading: true,
        commonError: ''
      }
    case GET_INVENTORYDEALS_SUCCESS:
      return {
        ...state,
        isTabLoading: false,
        inventory: {
          ...action.payload[0],
          ...action.payload[1]
        }
      }
    case GET_INVENTORYDEALS_FAILED:
      return {
        ...state,
        isTabLoading: false,
        commonError: action.payload
      }
    case GET_DEALSFORTRANSFER_REQUESTED:
      return {
        ...state,
        isModalLoading: true,
        modalError: '',
      }
    case GET_DEALSFORTRANSFER_SUCCESS:
      return {
        ...state,
        isModalLoading: false,
        dealsForTransfer: action.payload
      }
    case GET_DEALSFORTRANSFER_FAILED:
      return {
        ...state,
        isModalLoading: false,
        modalError: action.payload
      }
    case TRANSFER_SALED_REQUESTED:
      return {
        ...state,
        changeContract: false,
        isModalLoading: true,
      }
    case TRANSFER_SALED_SUCCESS:
      return {
        ...state,
        changeContract: true,
        isModalLoading: false,
      }
    case TRANSFER_SALED_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case OVERESTIMATION_DEALS_REQUESTED:
      return {
        ...state,
        isLoading: false,
        changeContract: false
      }
    case OVERESTIMATION_DEALS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        changeContract: true
      }
    case OVERESTIMATION_DEALS_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case CANCEL_OPERATION_REQUESTED:
      return {
        ...state,
        isLoading: false,
        changeContract: false
      }
    case CANCEL_OPERATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        changeContract: true
      }
    case CANCEL_OPERATION_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_PRINTEDFORM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_PRINTEDFORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        fileError: action.payload
      }
    case GET_PRINTEDFORM_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_CLIENTSCOUNT_RERQUEST:
      return {
        ...state,
        isClientCountLoading: true
      }
    case GET_CLIENTSCOUNT_SUCCESS:
      return {
        ...state,
        isClientCountLoading: false,
        clientsCount: action.payload
      }
    case GET_CLIENTSCOUNT_FAILED:
      return {
        ...state,
        isClientCountLoading: false,
        commonError: action.payload
      }
    case RESET_CLIENTS_COUNT:
      return {
        ...state,
        clientsCount: null
      };
    case TRANSFER_TO_RETENTION_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case TRANSFER_TO_RETENTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientContract: action.payload,
        commonError: ''
      }
    case TRANSFER_TO_RETENTION_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case PROLONG_CALCULATE_CLEAR:
      return {
        ...state,
        prolongCalculate: [],
      }
    case CONTRACT_SAVE_RESET:
      return {
        ...state,
        saveProlongCalculate: null
      }
    case CHANGE_CONTRACT_CLEAR:
      return {
        ...state,
        changeContract: false
      }
    case CONTRACT_ID_CLEAR:
      return {
        ...state,
        contractID: null
      }
    case CLIENT_CONTRACT_CLEAR:
      return {
        ...state,
        clientContract: {}
      }
    case CANCEL_CONTRACT_REQUEST:
      return {
        ...state,
        isLoading: true,
        contractError: ''
      }
    case CANCEL_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contractError: ''
      }
    case CANCEL_CONTRACT_FAILED:
      return {
        ...state,
        isLoading: false,
        contractError: action.payload
      }
    case MODAL_ERROR_CLEAR:
      return {
        ...state,
        modalError: ''
      }
    case SWITCH_CONTRACT_JEWELLERY:
      return {
        ...state,
        typeOfDeal: 'jewellery',
      }
    case SWITCH_CONTRACT_THINGS:
      return {
        ...state,
        typeOfDeal: 'things',
      }
    case SWITCH_CONTRACT_CARS:
      return {
        ...state,
        typeOfDeal: 'cars',
      }
    case CONTRACT_STATE_RESET:
      return lodash.cloneDeep(initialState)
    case CONTRACT_ERROR_CLEAR:
      return {
        ...state,
        commonError: '',
        fileError: ''
      }

    default:
      return state
  }
}

export default contractReducer
